import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import PagesHeader from "components/Header/PagesHeader.jsx";
import Footer from "components/Footer/Footer.jsx";
import pagesRoutes from "routes/pages.jsx";
import pagesStyle from "assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx";
import bgImage from "assets/img/loginPages.jpg";
import { connect } from "react-redux";

import BlockUi from "react-block-ui";

class Pages extends React.Component {
  constructor(props) {
    super(props);
    this.toggleBlocking = this.toggleBlocking.bind(this);
    this.state = {
      token: null,
      blocking: this.props.blocking,
    };
  }
  componentDidMount() {
    this.setState({ token: this.props.token });
    document.body.style.overflow = "unset";
  }

  toggleBlocking() {
    this.setState({ blocking: !this.state.blocking });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {

    this.setState({
      token: nextProps.token,
      blocking: nextProps.blocking,
      right: nextProps.rightPanel
    });
  }

  render() {
    const { classes, ...rest } = this.props;

    return (
      <div>
      <BlockUi tag="div" blocking={this.state.blocking} message="Please wait">

            <Switch>
              {pagesRoutes.map((prop, key) => {
                if (prop.collapse) {
                  return null;
                }

                if (prop.redirect) {
                  return (
                    <Redirect from={prop.path} to={prop.pathTo} key={key} />
                  );
                }
                return (
                  <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>

        </BlockUi>
      </div>
    );
  }
}

Pages.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
  };
}

export default connect(mapStateToProps)(withStyles(pagesStyle)(Pages));
